import ErrorHandler = newrelic.ErrorHandler;

export class NullRelic {
  private errorHandler: ErrorHandler;

  constructor() {
    this.errorHandler = window.localErrorHandler;
  }

  setErrorHandler(errorHandler: ErrorHandler): void {
    this.errorHandler = errorHandler;
  }

  addPageAction(): void {}

  noticeError(error: Error | string, customAttributes?: any): void {
    this.errorHandler(error);
  }

  setCustomAttribute(): void {}

  interaction(): NullInteraction {
    return new NullInteraction();
  }
}

export class NullInteraction {
  setName(name: string): NullInteraction {
    return this;
  }

  save(): NullInteraction {
    return this;
  }

  createTracer(name: string): VoidFunction {
    return (): void => {};
  }

  setAttribute(name: string, value: any): NullInteraction {
    return this;
  }
  end(): void {}
}
